module.exports = __webpack_public_path__ + "img/pdf.ee76a4a2.svg";